"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import useUCConsent from "~/hooks/use-uc-consent";

/**
 * KununuBox - Kununu rating widget for EON Grid Solutions
 * Only shows Kununu widget if user has consented to Kununu cookies
 */
export default function KununuBoxEonGridsolutions() {
  const $ = _c(3);
  const {
    consentStatus
  } = useUCConsent("Kununu");
  if (!consentStatus) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CustomImage className="object-contain object-top md:w-1/2 lg:w-full" height={854} src="images/jobad/eongrid/kununu_image.jpg" width={1280} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CustomLink blank={true} href="https://www.kununu.com/de/eon-grid-solutions?utm_source=widget&utm_campaign=widget_selfservice_scoreandreview"><CustomImage alt="Kununu Bewertung" height="100" src="https://assets.kununu.com/profiles-widgets/production/4c71674c-efa5-4c00-91e7-81d3a383118a_widget_score_review_count_logo_small.svg" width="170" /></CustomLink>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-8 md:flex md:gap-x-6 lg:block">{t0}<div className="mt-4 md:mt-0 lg:mt-4">{t1}<div className="mt-4"><p className="mb-2 font-medium text-xl">Richtig gesehen: Wir sind ein Top-Arbeitgeber!</p><p>Mit diesem Top-Score und einer Weiterempfehlungsrate von mehr als 90 % bei Kununu gehört die E.ON Grid Solutions zu den Top-Arbeitgebern Deutschlands. Besuche unser Profil und erfahre mehr über unsere Unternehmenskultur, Arbeitsbedingungen und Gehälter.</p><p>Du möchtest dir selbst ein Bild machen? Dann bewirb dich noch heute bei uns!</p></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}